// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3REZ7","inner":"styles_inner__TcKc4","title":"styles_title__2bzNR","value":"styles_value__1Rybf"};